import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'elio-emanager-front-shell',
  template: ` <router-outlet></router-outlet> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmanagerFrontShellComponent {}
